/**
 * The text a person selected inside one view: the one boundary every selection reader uses, so
 * a view never reads a selection made in another view of the same document, such as a second
 * Thread in a work tab beside it (F96, BA16-01). The only owner of the document's selection in
 * the web app (ADR-0039; `just check-one-owner`, rule `view-lookup`).
 */

/** The current selection's range, if text is selected and the selection lies wholly in `container`. */
export function selectedRangeIn(container: Element | null): Range | null {
  const selection = window.getSelection();
  if (container === null || selection === null || selection.isCollapsed || selection.rangeCount === 0) return null;
  const range = selection.getRangeAt(0);
  return container.contains(range.commonAncestorContainer) ? range : null;
}

/** Drop the selection once a view has acted on it, such as quoting it or turning it into a span. */
export function clearSelection(): void {
  window.getSelection()?.removeAllRanges();
}
